/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import ObserverContext from "../../context/Observer";
import { I18nContext } from "../../context/I18nProvider";
import { useInView } from "react-intersection-observer";
import Translate from "../../i18n/Translate";

import useScrollToTop from "../../hooks/useScrollToTop";

const About = () => {
  const { setActualComponent } = useContext(I18nContext);

  const { setElementInview } = useContext(ObserverContext);

  const [vision, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Scroll to top
  useScrollToTop();

  // Detectamos el scroll del contenedor line
  const handleScroll = (e) => {
    e.preventDefault();

    const top = window.scrollY < 240;

    setElementInview(!top);
  };

  // Seteamos el componente actual, para las traduccion de rutas
  useEffect(() => {
    setActualComponent("about");
  }, [setActualComponent]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="about">
      <div className="about__image triangle right"></div>

      <div className="about__content">
        <div className="about__content__header">
          <p>
            <Translate langkey="about.subtitle" />
          </p>
          <h1>
            <Translate langkey="about.title" />
          </h1>
        </div>

        <div className="about__content__text">
          <p>
            <Translate langkey="about.copy.paragraph1" />
          </p>
          <p>
            <Translate langkey="about.copy.paragraph2" />
          </p>
          <p>
            <Translate langkey="about.copy.paragraph3" />
          </p>
          <p>
            <Translate langkey="about.copy.paragraph4" />
          </p>

          <span>
            <Translate langkey="about.copy.paragraph5" />
          </span>
        </div>
      </div>

      <div className="about__group" ref={vision}>
        <div className="about__group__background"></div>

        <div className="about__group__container">
          <div className="about__group__item mision">
            <div>
              <h2>
                <Translate langkey="about.mision.title" />
              </h2>

              <p>
                <Translate langkey="about.mision.copy" />
              </p>
            </div>
          </div>

          <div
            className={
              inView
                ? "about__group__item vision isActive"
                : "about__group__item vision"
            }
          >
            <div>
              <h2>
                <Translate langkey="about.vision.title" />
              </h2>

              <p>
                <Translate langkey="about.vision.copy" />
              </p>
            </div>
          </div>

          <div className="about__group__item values">
            <div>
              <h2>
                <Translate langkey="about.values.title" />
              </h2>

              <p>
                <Translate langkey="about.values.copy" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
